import React from "react";
import classes from "./Question.module.css";
import Answers from "../Answers/Answers";
import InputForm from "../InputForm/InputForm";

const Question = ({ question, updateState, goBack, postCode }) => {
  let questionText = question.question;
  let pinkIndex = questionText.indexOf(question.highlightedWord);
  let pinkLength = question.highlightedWord.length;
  let firstText = questionText.substr(0, pinkIndex);
  let pinkText = questionText.substr(pinkIndex, pinkLength);
  let finalText = questionText.substr(pinkIndex + pinkLength);
  return (
    <React.Fragment>
      <div className={classes.question}>
        <span className={classes.questionHeader}>{firstText}</span>
        <span className={classes.questionHeader} style={{ color: "#ff58f3" }}>
          {pinkText}
        </span>
        <span>{finalText}</span>
      </div>
      {question.answers ? (
        <Answers
          updateState={updateState}
          question={question}
          goBack={goBack}
        />
      ) : (
        <InputForm updateState={updateState} postCode={postCode} />
      )}
    </React.Fragment>
  );
};

export default Question;
